import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

export const BusinessPage = () => {
  const { t } = useTranslation();

  return (
    <Box sx={{ padding: "40px 20px" }}>
      <Typography variant="h4">{t("pages.businessTitle")}</Typography>
    </Box>
  );
};
